import React from 'react';
import { Box, Stepper, Step, StepLabel } from '@mui/material';

const StepperForm = ({ steps, activeStep }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          '& .MuiStepConnector-line': {
            borderTopWidth: 2,
          },
          '& .MuiStep-root': {
            px: 1,
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              sx={{
                '& .MuiStepLabel-labelContainer': {
                  textAlign: 'center',
                },
                '& .MuiStepLabel-label': {
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  mt: 1,
                  color: activeStep === index ? 'primary.main' : 'grey.400',
                },
                '& .MuiStepIcon-root': {
                  fontSize: '2rem',
                  color: activeStep === index ? 'primary.main' : activeStep > index ? 'success.main' : 'grey.300',
                },
                '& .MuiStepIcon-text': {
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  fill: 'common.white',
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StepperForm;